import { createFileRoute } from '@tanstack/react-router'

import { loadCanCreateEndorsement } from '#/modules/contract/front-office/contract-details-page/components/endorsement/load-can-create-endorsement.utils.ts'
import { ContractDetailsPageSkeleton } from '#/modules/contract/front-office/contract-details-page/contract-details-page-skeleton.tsx'
import { ContractDetailsPage } from '#/modules/contract/front-office/contract-details-page/contract-details-page.tsx'
import { CONTRACT_DOCUMENTS_QUERY_OPTIONS } from '#/modules/contract/queries/contract-documents-query-options.ts'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/contracts/$subscriptionId/')({
  beforeLoad: async (options) => {
    await requirePermissions(options, ['contract.read'])
    return { canCreateEndorsement: await loadCanCreateEndorsement() }
  },
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.ensureQueryData(
        context.trpc.contracts.getMyContract.queryOptions(
          {
            subscriptionId: params.subscriptionId,
            includeTerminatedBeforeOneMonth: true,
          },
          frontOfficeQueryOptions,
        ),
      ),
      context.queryClient.ensureQueryData(
        context.trpc.organizations.getOrganizationInfoBySubscriptionId.queryOptions(
          params.subscriptionId,
          frontOfficeQueryOptions,
        ),
      ),
      // Prefetch, not ensure: the fiscal attestations section is optional and must not take the page down.
      // Awaited all the same, because the section hides itself when there is no attestation, so this decides
      // the page's layout. That puts the loader at four requests, over the 1-3 routing-frontend.md prescribes.
      context.queryClient.prefetchQuery(
        context.trpc.subscriptionDocuments.listContractDocuments.queryOptions(
          { subscriptionId: params.subscriptionId },
          CONTRACT_DOCUMENTS_QUERY_OPTIONS,
        ),
      ),
      // Prefetch, not ensure: a rejected endorsement query must not take the whole page down.
      context.canCreateEndorsement
        ? context.queryClient.prefetchQuery(
            context.trpc.endorsement.getPendingEndorsements.queryOptions(
              {
                subscriptionId: params.subscriptionId,
              },
              frontOfficeQueryOptions,
            ),
          )
        : Promise.resolve(),
    ]),
  pendingComponent: ContractDetailsPageSkeleton,
  pendingMs: 150,
  component: ContractDetailsRoute,
})

function ContractDetailsRoute() {
  const { subscriptionId } = Route.useParams()
  return <ContractDetailsPage subscriptionId={subscriptionId} />
}
